import { camelCase, kebabCase, transform, upperFirst } from 'lodash';

const objToJSONAPI = obj => {
  const { id, type, ...attributes } = obj;

  let response = {};

  if (id && id !== '') {
    response.id = id;
  }

  response.type = type;
  response.attributes = transform(attributes, (attrs, v, k) => {
    attrs[kebabCase(k)] = v;
  });

  return response;
};

const objFromJSONAPI = obj => {
  const { id, type, attributes } = obj;

  const newAttributes = transform(attributes, (attrs, v, k) => {
    attrs[camelCase(k)] = v;
  });

  return { id, type, ...newAttributes };
};

export const toJSONAPI = input => {
  let data = {};

  if (Array.isArray(input)) {
    data = input.map(obj => objToJSONAPI(obj));
  } else {
    data = objToJSONAPI(input);
  }

  return { data };
};

export const fromJSONAPI = doc => {
  if (Array.isArray(doc.data)) {
    return doc.data.map(obj => objFromJSONAPI(obj));
  }

  return objFromJSONAPI(doc.data);
};

const errorSourcePointerField = error => {
  if (error.source && error.source.pointer) {
    let pointerParts = error.source.pointer.split('/');
    return camelCase(pointerParts.pop());
  }
};

export const extractValidationErrors = doc => {
  let validationErrors = {};

  if (Array.isArray(doc.errors)) {
    doc.errors.forEach(error => {
      if (error.status !== '422') {
        return;
      }

      const field = errorSourcePointerField(error);
      if (field) {
        validationErrors[field] = { ...error, title: upperFirst(error.title) };
      }
    });
  }

  return validationErrors;
};



// WEBPACK FOOTER //
// ./src/utils/jsonapi/serializer.js